<template>
  <div class="tl">
    <Carousel class="w-80-ns center" :pics="images" :homeProp="true" :perPageCount="1" :fill="false" :fast="4000" />
    <div class="desc f3-ns f4 w-80-ns w-100 pt1-ns pt3 fw3 center ph2-ns ph3">
      <span class="fw4 black">All<span class="red">on</span> Construction</span> is a fully licensed, bonded and insured general building contractor based in Los Angeles, CA.<br/><br/>
      For over 20 years we’ve created innovative and practical solutions for our valued commercial and residential clientele.<br/><br/>
      We’re dedicated to superior craftsmanship, unwavering integrity and great relationships.<br/><br/>
      <a :href="info.tel" class="red link">Call us</a> today for a free estimate or some helpful advice.<br/><br/>
    </div>
  </div>
</template>

<script>
import Carousel from '@/components/Carousel'
export default {
  name: 'Home',
  props: ['info'],
  data() {
    return {
      current_img: 0,
      position: null,
      images: [
      ]
    };
  },
  methods: {
    importAll(r) {
      r.keys().forEach(key => (this.images.push({ pathLong: r(key), pathShort: key })));
    },
    handleScroll (e) {
      this.position = window.scrollY
    },
    next: function() {
      this.current_img += 1;
    },
    prev: function() {
      this.current_img -= 1;
      if (this.current_img < 0) {
        this.current_img = (this.images.length - 1);
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);

  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    this.importAll(require.context('../assets/murietta/', true, /\.jpg$/));
  },
  components: { Carousel }
};
</script>

<style scoped>
.desc {
  /* color:rgb(87, 87, 87); */
}
.hide {
  display: none;
  transition: 2s;
}
.arrow {
  max-width: 20px;
}
@keyframes gbounce { 
  0% { transform: translateY(0); }
  30% { transform: translateY(-5px); }
  50% { transform: translateY(0); }
  100% { transform: translateY(0); }
}

.f25 {
  font-size: 1.8rem;
}
.gbounce {
  animation: gbounce 2s;
  animation-timing-function: ease;
  animation-iteration-count: infinite;
}
.b1 {
  font-weight: 500;
}
.button {
  background: transparent;
  /* border-top: none;
  border-left: none;
  border-right: none; */
  border: .5px solid black;
  color: black;
  cursor: pointer;
  text-align: center;
  font-weight: 500;
}
.button:hover {
  border-top: .5px solid black;
  border-left: .5px solid black;
  border-right: .5px solid black;
  color: black;
  transition: .5 ease-in
}
.title-section:before,
.title-section:after {
  content: "";
  margin: 0px 5px 0px 5px;
  border-top: 2px solid #000;
  width: 10%;
  padding-bottom: 4px;
  display: inline-block;
}
.big-section:before,
.big-section:after {
  content: "";
  margin: 0px -5px 0px -10px;
  border-top: 1px solid #000;
  width: 4%;
  padding-bottom: 10px;
  display: inline-block;
}
.cover1 {
  background: url('https://images.unsplash.com/photo-1537726227291-6163e542febc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2284&q=80') no-repeat;
  background-size: cover;
  height: 64vh;
}

.cover2 {
  background: url('https://images.unsplash.com/photo-1448630360428-65456885c650?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1347&q=80') no-repeat;
  background-size: cover;
  height: 64vh;
}

@media only screen 
and (min-device-width : 375px) 
and (max-device-width : 812px)
and (-webkit-device-pixel-ratio : 3) { 
  .cover1 {
    background-position: 41% 0%;
    height: 70vh;
  }
    .cover2 {
    background-position: 41% 0%;
    height: 70vh;
    width: 100%;
  }
}
</style>